import { render } from "./HelpMe.vue?vue&type=template&id=16d0952b"
import script from "./HelpMe.vue?vue&type=script&lang=js"
export * from "./HelpMe.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__